import base from '../dr-base'
import drComboBox from './dr-combo-box.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-combo-box',
  name: 'Combo box',
  group: 'Input widgets',
  icon: 'pen-alt',
  ...base,
  properties: {
    ...base.properties,
    Value: {
      name: 'vuetifyWidgets.dr-combo-box.value',
      type: 'string',
      hint: 'vuetifyWidgets.dr-combo-box.hint',
      component: 'dr-value-editor'
    },
    Required: {
      name: 'vuetifyWidgets.general.required',
      type: 'boolean'
    },
    Caption: {
      name: 'vuetifyWidgets.dr-combo-box.caption',
      type: 'string'
    },
    Items: {
      name: 'vuetifyWidgets.dr-combo-box.items',
      type: 'string',
      default: '',
      hint: 'vuetifyWidgets.dr-combo-box.hint',
      component: 'dr-value-editor'
    },
    Disabled: {
      name: 'vuetifyWidgets.dr-combo-box.disabled',
      type: 'string',
      default: ''
    },
    Style: {
      name: 'vuetifyWidgets.dr-combo-box.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    IsMultiple: {
      name: 'Multiple',
      type: 'boolean',
      default: false
    },
    IsClearable: {
      name: 'Clearable',
      type: 'boolean',
      default: false
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-combo-box.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drComboBox,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
